import { lazy } from "react"

const SlackConnectPage$$__react__lazy__component = lazy(() => 
    import("./SlackConnectPage__original__module.mjs")
        .then(module => module.get_$$SlackConnectPage$$SlackConnectPage$$react__component$$2ssqpnn2r47u2())
        .then(component => ({ default: component }))
)

export const get_$$SlackConnectPage$$SlackConnectPage$$react__component$$2ssqpnn2r47u2 = () => SlackConnectPage$$__react__lazy__component